module.exports = __webpack_public_path__ + "img/logo.6bce413b.png";